module.exports = __webpack_public_path__ + "img/shopee.53fbd4ff.png";